export default [
    {
        name: 'Pleitos',
        url: '/pleitos/financeiro',
        icon: 'fa fa-file-text-o',
        regras: 'PLEITOS-FINAN-00',
        badge: {
            variant: 'primary',
            text: 'FINANCEIRO'
        }
    }
]